'use client';

import { AD_UNIT_IDS, WELLO_IMAGE_PREFIX_URL } from '@/constants';
import { ROUTES } from '@/constants/routes';

import { BenefitAdCard } from './BenefitAdCard';
import { BenefitCard } from './BenefitCard';

export const LowerBenefitBanner = () => {
  return (
    <section className="px-16">
      <div className="grid grid-cols-2 gap-12">
        <BenefitCard
          backgroundColor="#FFFDF4"
          title="웰포인트"
          mainText="출석체크하고"
          subText="포인트 받기"
          src={`${WELLO_IMAGE_PREFIX_URL}/static/home/stamp.png`}
          href={ROUTES.ATTENDANCE_DAILY_CHECK.pathname}
        />

        {/* BM 하단 광고 (광고 없을 시 기존 카드 표시) */}
        <BenefitAdCard
          unitId={AD_UNIT_IDS.HOME_NATIVE_BM_BOTTOM}
          backgroundColor="#FFF5FB"
          fallback={
            <BenefitCard
              backgroundColor="#FFF5FB"
              title="정책 알림 서비스"
              mainText="행정안전부"
              subText="혜택알리미"
              src={`${WELLO_IMAGE_PREFIX_URL}/static/home/mois.png`}
              href={ROUTES.BENEFIT_NOTIFICATION_AGREEMENT.pathname}
            />
          }
        />
      </div>
    </section>
  );
};
